export default __webpack_public_path__ + "static/media/shard-relationships-active.c3f80e3e.jpg";